import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector.js';
import { WbsTypeIdSelector } from '../../../reducers/elementTypes.js';
import { rootElementIdSelector, currentProjectIdSelector } from '../../../reducers/projects.js';

import Loading from '../../../components/Loading.js';
import WBSContainer from './WBSContainer.js';

const WBSWrapperSelector = immutableCreatorSelector(
  [
    WbsTypeIdSelector,
    rootElementIdSelector,
    currentProjectIdSelector,
  ],
  (
    wbsTypeId,
    rootElementId,
    currentProjectId,
  ) => {
    return {
      wbsTypeId,
      rootElementId,
      currentProjectId,
    };
  }
);

@connect(WBSWrapperSelector)
class WBSWrapper extends Component {
  render() {
    const { wbsTypeId, rootElementId } = this.props;
    if (!wbsTypeId || !rootElementId) return <Loading loadingMessage="WBS Elements are Loading..." />;

    return <WBSContainer {...this.props} />;
  }
}

WBSWrapper.propTypes = {
  wbsTypeId: PropTypes.string,
  rootElementId: PropTypes.string,
  currentProjectId: PropTypes.string,
};

export default WBSWrapper;



// WEBPACK FOOTER //
// ./src/views/Project/WBS/WBSWrapper.js